module.exports={render:function (){with(this) {
  return _h('tbody', {
    attrs: {
      "id": id
    }
  }, [_h('tr', [_m(0), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(total.nettoValue))]), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(total.vatValue))]), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(total.bruttoValue))])])])
}},staticRenderFns: [function (){with(this) {
  return _h('th', {
    staticClass: "empty",
    attrs: {
      "colspan": "6"
    }
  }, ["Razem"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/InvoiceTotal.vue
 ** module id = 172
 ** module chunks = 2
 **/